import React, { useEffect, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { Memberlist } from "../../apis/api/MembershipApi";
import Cookies from "js-cookie";
import MembershipPlan from "./MembershipPlan";
import { motion } from "framer-motion";
import "./Membership.css";

const Membership = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const company_id = Cookies.get("company_id");

  const { membership_list } = useSelector((state) => state.MembershipSlice);
  
  useEffect(() => {
    dispatch(Memberlist({ company_id: company_id }));
  }, [dispatch, company_id]);


  useEffect(() => {
    setData(membership_list?.data || []);
  }, [membership_list]);


  return (
    <motion.div
      className="ms-wrap"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
    >
      <div className="ms-hero">
        <h1 className="ms-title">Membership</h1>
        <p className="ms-subtitle">Choose the plan that best fits your growth journey.</p>
      </div>

      <div className="ms-grid">
        {data?.map((plan, index) => (
          <MembershipPlan key={plan.id || index} plan={plan} allPlans={data} index={index} />
        ))}
      </div>
    </motion.div>
  );
};

export default Membership;
